export default {
  updateDate: 'Update Date',
  status: 'Status',
  plant: 'Plant',
  platformOrderNo: 'Platform Order No',
  giOrderNo: 'GI Order No',
  bzOmsOrderNo: 'BZ OMS Order No',
  rfidEpc: 'RFID EPC',
  carrierTrackingNo: 'Carrier Tracking No',
  requiredBingQty: 'Required Bind Qty',
  actualTotalBinds: 'Actual Total Binds',
  rfidBinds: 'RFID Binds',
  qrBinds: 'QR Binds',
  definition1: `
    <b>Status Signal (Report Left)</b>: 
    Blue - Product is in the binding process; Green - Product has been successfully bound; Gray - Product has been unbound.`,
  definition2: `
    <b>RFID EPC/QR Code Strikethrough</b>: 
    This indicates that the product has been unbound from the order number.`
}
